import {
  Approve,
  Close,
  Delete,
  Details,
  Edit,
  PdfDownload,
  Reopen,
  Root,
  StarAction,
  View,
} from './components';

export const ActionsCell = {
  Root,
  Details,
  Edit,
  Approve,
  Close,
  Delete,
  PdfDownload,
  Reopen,
  StarAction,
  View,
};
